module.exports = window.rails_asset_host + "/packs/media/src/Login/assets/images/3scale_Logo_Reverse-e51c14433a8fa3f4c58177eb27756c81.png";